import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { MeasurementSet } from './measurement-set';
export { MeasurementSet };
import { measurementSetSchema } from '@schemas/business-objects/measurement-set';
import { MeasurementFormArray } from './measurement-form-group';
import { SalePhotoFormGroup } from './sale-photo-form-group';
import { UserFormGroup } from './user-form-group';

export class MeasurementSetFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    createdOn: SchemaFormControl;
    referenceLength: SchemaFormControl;
    scaleFactor: SchemaFormControl;
    salePhotoId: SchemaFormControl;
    salePhoto: SalePhotoFormGroup;
    createdById: SchemaFormControl;
    createdBy: UserFormGroup;
    measurements: MeasurementFormArray;
  };

  declare value: Partial<MeasurementSet>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(measurementSetSchema, MeasurementSet, data, options);
  }

  get object(): MeasurementSet {
    return new MeasurementSet(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'salePhoto':
        return new SalePhotoFormGroup();
      case 'createdBy':
        return new UserFormGroup();
      case 'measurements':
        return new MeasurementFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<MeasurementSet[]> {
    return MeasurementSet.find(filter);
  }

  static async findOne(filter?: any): Promise<MeasurementSet | null> {
    return MeasurementSet.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<MeasurementSet> {
    return MeasurementSet.findById(id, filter);
  }

  static async create(data: Partial<MeasurementSet>): Promise<MeasurementSet> {
    return MeasurementSet.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<MeasurementSet>,
  ): Promise<MeasurementSet> {
    return MeasurementSet.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return MeasurementSet.deleteById(id);
  }
}

export class MeasurementSetFormArray extends PersistedFormArray {
  readonly entityName = 'MeasurementSet' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(measurementSetSchema, MeasurementSet, options);
  }

  protected override createItemGroup() {
    return new MeasurementSetFormGroup();
  }

  get array(): MeasurementSet[] {
    return this.controls.map((group: MeasurementSetFormGroup) => group.object);
  }
}

export class MeasurementSetPersistedArray extends PersistedArray<MeasurementSet> {
  readonly entityName = 'MeasurementSet' as const;

  constructor(options?: PersistedArrayOptions) {
    super(MeasurementSet, options);
  }
}
